export function renderNumberWithDecimalsOrInteger(number: number, decimalPlaces: number): number {
    if (Number.isInteger(number)) {
        return number;
    } else {
        return parseFloat(number.toFixed(decimalPlaces));
    }
}

export function getHoursArray(rangeStartNumber: number, rangeEndNumber: number): string[] {
    const timesArray = [];
    for (let hour = rangeStartNumber; hour < rangeEndNumber; hour++) {
        const hourModulo = hour % 24;
        const formattedHour = hourModulo < 10 ? '0' + hourModulo : hourModulo;
        timesArray.push(formattedHour.toString());
    }
    return timesArray;
}

export function getCentimetersFromMeters(meters: number): number {
    return meters * 100;
}

export function getMetersFromCentimeters(centimeters: number): number {
    return centimeters / 100;
}

export function getSquareMetersFromSquareCentimeters(squareCentimeters: number): number {
    return squareCentimeters / 10000;
}

export function getSquareCentimetersFromSquareMeters(squareMeters: number): number {
    return squareMeters * 10000;
}
